import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import VehicleSelection from '../VehicleSelection';
import OilSelection from '../../OilSelection';
import LocationSelection from '../../LocationSelection';
import {
  ICoordinate,
  ICountry,
  IModal,
  IOilFilter,
  IProductCategory,
  IState,
  IVehicle,
  ProductCategory,
  Replacement,
} from '../../../interface';
import {Dispatch} from 'redux';
import actions from '../../../redux/actions';
import {ModalHref} from '../../../interface/emnu';
import Modal from '../../Modal';
import FindTheRightOil from '../../FindTheRightOil';
import { isOnlyWTBcountry } from '../../../utils/isOnlyWTBcountry';
import {useSearchParams} from 'react-router-dom';
import { useAppName } from '../../../hooks/use-app-names';
import { APPNAME, FASTSCAN } from '../../../constants';

const cx = classnames.bind(style);

export interface IProps extends IOilFilter {
  modal: IModal;
  replacements: Replacement;
  setOverlay: (value: boolean) => void;
  setProductCategories: (value: string[]) => void;
  setVehicle: (value: IVehicle | undefined) => void;
  setModal: (value: IModal) => void;
  position: ICoordinate;
  productCategoriesList: ProductCategory[] | null;
  country: ICountry;
}

//Top filter for vehicle selection & product categories & product recommendations & manual location
function FilterSection(props: IProps) {
  const {
    productCategories,
    replacements,
    setOverlay,
    vehicle,
    setProductCategories,
    setVehicle,
    modal,
    setModal,
    position,
    productCategoriesList,
    country: currentCountry,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const [searchParams, setSearchParams] = useSearchParams();
  const i18n = localStorage.getItem('languageCode') as string;
  const country = (localStorage.getItem('countryCode') ||
    process.env.REACT_APP_COUNTRYCODE) as string;
  const [productCategoriesDrop, setProductCategoriesDrop] = useState<
    IProductCategory[]
  >([]);
  //set product categories & product recommendations when vehicle selection drodown is selected
  useEffect(() => {
    setProductCategoriesDrop([]);
    productCategoriesList
      ? setProductCategoriesDrop(
          //eslint-disable-next-line
          _.map(productCategoriesList, (o: any) => {
            return _.includes(productCategories, _.toString(o['id']))
              ? {...o, checked: true}
              : {...o, checked: false};
          }),
        )
      : setProductCategoriesDrop([]);
  }, [vehicle, productCategoriesList]);
  //Change the product categories dropdown
  const changeLubricants = (value: IProductCategory) => {
    setProductCategoriesDrop(
      _.unionBy([...productCategoriesDrop, value], 'id'),
    );
    setProductCategories(
      _.chain([...productCategoriesDrop, value])
        .uniqBy('id')
        .filter('checked')
        .orderBy('id')
        .map((d) => _.toString(d['id']))
        .value(),
    );
  };
  const selectVehicleHandle = (value: string | number) => {
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({visibie: false, href: 0});
  };
  const selectProductHandle = (value: string | number) => {
    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setModal({visibie: false, href: 0});
  };
  return (
    <>
      <div className={cx('filter-section')}>
        <div className={cx('inner')}>
          {/* vehicle selection dropdown */}
          <div className={cx('block', 'vehicle')}>
          <VehicleSelection
              setVehicle={setVehicle}
              disabled={isOnlyWTBcountry(currentCountry.isoCode)}
            />
          </div>
          {/* vehicle product categories dropdown */}
          <div className={cx('block', 'oil')}>
            <OilSelection
              dataList={productCategoriesDrop}
              type='category'
              onChangeHandler={changeLubricants}
            />
          </div>
          {/* manual location autocomplete */}
          <div className={cx('block', 'location')}>
            <LocationSelection position={position} />
          </div>
        </div>
        {/* trigget the flyout on mobile */}
        <span
          className={`button ${cx('filter-list')}`}
          onClick={() => setOverlay(true)}
          role='button'
        ></span>
      </div>

      {_.isEqual(modal.href, ModalHref.FindTheRightOil) && modal.visibie && (
        <Modal className={cx('abs-modal', 'abs-find-modal')}>
          <FindTheRightOil
            country={country}
            onVehicleSelect={(value) => selectVehicleHandle(value)}
            onProductSelect={(value) => selectProductHandle(value)}
            i18n={i18n}
            locales={replacements}
            baseAPI={process.env.REACT_APP_PROVIDER_URL}
            restore={isFastScan}
          />
        </Modal>
      )}
    </>
  );
}

const mapStateToProps = (state: IState) => ({
  vehicle: state.filter.vehicle,
  modal: state.modal,
  productCategories: state.filter.productCategories,
  productCategoriesList: state.productCategoriesList,
  country: state.country,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setProductCategories: (productCatgories: string[]) =>
    dispatch(actions.setProductCategories(productCatgories)),
  setVehicle: (vehicle: IVehicle | undefined) =>
    dispatch(actions.setVehicle(vehicle)),
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
